/** Normaliza IDs INE guardados como entero en BD (3 → "03", 3070 → "03070"). */

export function normalizeProvinciaId(id) {
  if (id == null || id === "") return "";
  const s = String(id).trim();
  if (/^\d+$/.test(s)) return s.padStart(2, "0").slice(-2);
  return s;
}

export function normalizePoblacionId(id) {
  if (id == null || id === "") return "";
  const s = String(id).trim();
  if (/^\d+$/.test(s)) return s.padStart(5, "0");
  return s;
}

export function provinciaIdsEqual(a, b) {
  return normalizeProvinciaId(a) === normalizeProvinciaId(b);
}

export function poblacionIdsEqual(a, b) {
  return normalizePoblacionId(a) === normalizePoblacionId(b);
}
